<template>
    <table-user-value :value="value">
        <template v-slot:prepend v-if="value?.lock">
            <v-tooltip open-delay="1000">
                <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" icon="mdi-lock-outline" :color="$api.me.user.id == value?.lock.user ? 'green' : 'red'" class="ma-1"></v-icon>
                </template>
                <v-lazy>
                    <user-detail :user="lockUser">
                        <template v-slot:prepend>
                            <b>{{ $tr('Заблокировано пользователем') }}</b>
                            <br>
                            {{ value?.lock.scope }}
                        </template>
                    </user-detail>
                </v-lazy>
            </v-tooltip>
        </template>
    </table-user-value>
</template>

<script>
import TableUserValue from '@topomatic/tap/src/components/TableUserValue.vue';
import UserDetail from '@topomatic/tap/src/components/UserDetail.vue';

export default {
    name: 'TableUserLockValue',
    components: {
        TableUserValue,
        UserDetail,
    },
    props: {
        value: undefined,
    },
    computed: {
        lockUser() {
            return this.$api.get_user(this.value.lock.user);
        },
    },
};
</script>

<style>

</style>
